import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { loading, isAuthenticated } = useContext(AuthContext);

  if (loading) return null; // simple for now (we can add loader later)
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
}
